import { render, staticRenderFns } from "./reviewList.vue?vue&type=template&id=20335f7a&scoped=true&"
import script from "./reviewList.vue?vue&type=script&lang=js&"
export * from "./reviewList.vue?vue&type=script&lang=js&"
import style0 from "./reviewList.vue?vue&type=style&index=0&id=20335f7a&scoped=true&lang=css&"
import style1 from "./reviewList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20335f7a",
  null
  
)

export default component.exports